// The browser's timezone and clock, reported once at web sign-up and read by
// User.browser_time_settings on the backend. An empty value means "unknown":
// the backend then keeps its defaults (Berlin, 24 hours).
export interface BrowserTimeSettings {
  timezone: string;
  timeFormat: "12" | "24" | "";
}

export function detectBrowserTimeSettings(
  language: string = navigator.language
): BrowserTimeSettings {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? "";
    // The clock follows the browser's language (en-US → 12, en-GB/de → 24),
    // not the page locale, which only says which language fobizz is shown in.
    const { hourCycle } = new Intl.DateTimeFormat(language, {
      hour: "numeric",
    }).resolvedOptions();
    let timeFormat: BrowserTimeSettings["timeFormat"] = "";
    if (hourCycle === "h11" || hourCycle === "h12") timeFormat = "12";
    else if (hourCycle === "h23" || hourCycle === "h24") timeFormat = "24";

    return { timezone, timeFormat };
  } catch {
    return { timezone: "", timeFormat: "" };
  }
}

// OmniAuth only keeps the query string of the request that starts SSO, so the
// settings go into the SSO button URL rather than into hidden form inputs.
export function withBrowserTimeSettings(
  url: string,
  settings: BrowserTimeSettings
): string {
  const parsed = new URL(url, window.location.origin);
  if (settings.timezone) parsed.searchParams.set("timezone", settings.timezone);
  if (settings.timeFormat)
    parsed.searchParams.set("time_format", settings.timeFormat);

  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
